import { useTranslation } from "react-i18next";

/**
 * Thin wrapper on `useTranslation` so consumer sites can `import { useT }`
 * without pulling react-i18next into every file. Signature mirrors i18next:
 *   const { t, i18n } = useT();               // default 'common' namespace
 *   const { t } = useT("home");               // 'home' namespace
 *   const { t } = useT(["home", "nav"]);      // multi-namespace fallback
 */
export function useT(ns) {
  return useTranslation(ns);
}

export default useT;
